import { Injectable } from "@angular/core";
import * as jwtDecode from "jwt-decode";
import { ReplaySubject } from "rxjs";
import { map, skip } from "rxjs/operators";

import { GlobalJwt, MartJwt } from "@lantern/app/models";

import { CrossStorageService } from "../utils/cross-storage";

export const GLOBAL_AUTH_JWT_KEY = "global-auth-jwt";
export const MART_AUTH_JWT_KEY = "mart-auth-jwt";

@Injectable()
export class AuthJwtService {
  globalJwtToken = new ReplaySubject<string | undefined>(1);
  globalJwt = this.globalJwtToken.pipe(
    map((jwt) => (jwt != null ? jwtDecode<GlobalJwt>(jwt) : undefined))
  );

  martJwtToken = new ReplaySubject<string | undefined>(1);
  martJwt = this.martJwtToken.pipe(
    map((jwt) => (jwt != null ? jwtDecode<MartJwt>(jwt) : undefined))
  );

  constructor(
    private crossStorage: CrossStorageService
  ) {
    this.init();
  }

  private init(): void {
    this.initGlobalJwt();
    this.initMartJwt();
  }

  protected async initGlobalJwt(): Promise<void> {
    let globalJwt;
    try {
      globalJwt = await this.crossStorage.get(GLOBAL_AUTH_JWT_KEY);
    } catch {
      throw new Error("Failed to connect to global auth cross storage!");
    }

    this.globalJwtToken.next(
      typeof globalJwt === "string" ? globalJwt : undefined
    );

    this.globalJwtToken.pipe(skip(1)).subscribe((newGlobalJwt) => {
      if (newGlobalJwt != null) {
        this.crossStorage.set(GLOBAL_AUTH_JWT_KEY, newGlobalJwt);
      } else {
        this.crossStorage.del(GLOBAL_AUTH_JWT_KEY);
      }
    });
  }

  protected initMartJwt(): void {
    const martJwt = localStorage.getItem(MART_AUTH_JWT_KEY);
    this.martJwtToken.next(martJwt != null ? martJwt : undefined);

    this.martJwtToken.pipe(skip(1)).subscribe((newMartJwt) => {
      if (newMartJwt != null) {
        localStorage.setItem(MART_AUTH_JWT_KEY, newMartJwt);
      } else {
        localStorage.removeItem(MART_AUTH_JWT_KEY);
      }
    });
  }
}
